export default "__VITE_ASSET__Ygwhfqa$__"